import cloudFunctionApi from '../../../cloudfunctions';
import firebaseApi from '../../../firebase/firebaseApi';
import { useAbortController } from '../../../hooks/useAbortController';
import {
	useUserAuthContext,
	useUserDetailsContext,
} from '../../../providers/UserProvider';
import { LoadingDots } from '../../Management/subcomponents/LoadingDots';
import { Inductions } from './Inductions';

export const InductionsWrapper = (): JSX.Element => {
	const userDetails = useUserDetailsContext();
	const abortSignal = useAbortController();
	const user = useUserAuthContext();

	return !userDetails || !user ? (
		<LoadingDots />
	) : (
		<Inductions
			userDetails={userDetails}
			firebaseApi={firebaseApi}
			cloudFunctionApi={cloudFunctionApi}
			user={user}
			abortSignal={abortSignal}
		/>
	);
};
